import {getClosestPoint, getIntersectCords, getMousePositionOnField} from "../../../../../../helpers/sqftHelper";
import store from "../../../../../../../../store";

export const getHorizontalLineIntersectionPoints = (mousePos, shape, lines = shape.getLines()) => {
  const mousePosOnFiled = getMousePositionOnField(mousePos.x, mousePos.y);
  const serverState = store.getState().serverState;
  const pos = shape.getPosition();

  const mousePosOnShape = {x: mousePosOnFiled.x - pos.x, y: mousePosOnFiled.y - pos.y};
  let verticalLinePoint1 = {x: -serverState.windowWidth, y: Math.round10(mousePosOnShape.y, -1)};
  let verticalLinePoint2 = {x: serverState.windowWidth, y: Math.round10(mousePosOnShape.y, -1)};
  let [intersectionXPointAndLine1, intersectionXPointAndLine2] = getClosestIntersectionPoints(
    lines, verticalLinePoint1, verticalLinePoint2, mousePosOnShape
  );

  if (intersectionXPointAndLine1 && intersectionXPointAndLine2) {
    intersectionXPointAndLine1.intersectionCords = {x: Math.round10(intersectionXPointAndLine1.intersectionCords.x, -1), y: Math.round10(mousePosOnFiled.y - pos.y, -1)};
    intersectionXPointAndLine2.intersectionCords = {x: Math.round10(intersectionXPointAndLine2.intersectionCords.x, -1), y: Math.round10(mousePosOnFiled.y - pos.y, -1)};

    return [intersectionXPointAndLine1, intersectionXPointAndLine2]
  }

  return []
}

export const getVerticalLineIntersectionPoints = (mousePos, shape,  lines = shape.getLines()) => {
  const mousePosOnFiled = getMousePositionOnField(mousePos.x, mousePos.y);
  const serverState = store.getState().serverState;
  const pos = shape.getPosition();

  const mousePosOnShape = {x: mousePosOnFiled.x - pos.x, y: mousePosOnFiled.y - pos.y};
  //let verticalLinePoint1 = {x: -serverState.windowWidth, y: mousePosOnShape.y};
  //let verticalLinePoint2 = {x: serverState.windowWidth, y: mousePosOnShape.y};

  let verticalLinePoint1 = {x: Math.round10(mousePosOnFiled.x - pos.x, -1), y: -serverState.windowHeight};
  let verticalLinePoint2 = {x: Math.round10(mousePosOnFiled.x - pos.x, -1), y: serverState.windowHeight};
  // let verticalLinePoint1 = {x: Math.ceil10(mousePosOnFiled.x - pos.x, 2), y: -serverState.windowHeight};
  // let verticalLinePoint2 = {x: Math.ceil10(mousePosOnFiled.x - pos.x, 2), y: serverState.windowHeight};

  let [intersectionPointAndLine1, intersectionPointAndLine2] = getClosestIntersectionPoints(
    lines, verticalLinePoint1, verticalLinePoint2, mousePosOnShape
  );

  if (intersectionPointAndLine1 && intersectionPointAndLine2) {
    intersectionPointAndLine1.intersectionCords = {x: Math.round10(mousePosOnFiled.x - pos.x, -1), y: Math.round10(intersectionPointAndLine1.intersectionCords.y, -1)};
    intersectionPointAndLine2.intersectionCords = {x: Math.round10(mousePosOnFiled.x - pos.x, -1), y: Math.round10(intersectionPointAndLine2.intersectionCords.y, -1)};
    // let intersectionPoint1 = {x: Math.ceil10(mousePosOnFiled.x - pos.x, 2), y: intersectionXPoint1.y};
    // let intersectionPoint2 = {x: Math.ceil10(mousePosOnFiled.x - pos.x, 2), y: intersectionXPoint2.y};

    return [intersectionPointAndLine1, intersectionPointAndLine2]
  }

  return []
}

/**
 * Return only two closest points from the array of intersectionPointsAndLines
 * @param {*} lines
 * @param {*} intersectionPoint1
 * @param {*} intersectionPoint2
 * @param {*} closestPont
 * @return {array} [{intersectionPoint, line}]
 */
export const getClosestIntersectionPoints = (lines, intersectionPoint1, intersectionPoint2, closestPont) => {
  let intersectionPointsAndLines = getIntersectionPointsAndLines(lines, intersectionPoint1, intersectionPoint2)
  if (intersectionPointsAndLines.length >= 1) {
    let intersectionPoints = intersectionPointsAndLines.map(pointAndLine => pointAndLine.intersectionCords);
    let closestPont1 = getClosestPoint(closestPont, intersectionPoints);
    let intersectionPointsAndLinesWithout1Point = intersectionPointsAndLines.filter(pointAndLine => pointAndLine.intersectionCords !== closestPont1);
    intersectionPoints = intersectionPointsAndLinesWithout1Point.map(pointAndLine => pointAndLine.intersectionCords);

    let closestPont2 = getClosestPoint(closestPont, intersectionPoints);

    return intersectionPointsAndLines.filter(pointAndLine => {
      return pointAndLine.intersectionCords === closestPont1 || pointAndLine.intersectionCords === closestPont2
    });
  }

  return intersectionPointsAndLines
}

/**
 * Return all intersectionsPointsAndLines between lines and two coords
 * @param {*} lines
 * @param {*} intersectionPoint1
 * @param {*} intersectionPoint2
 * @return {array} [{intersectionPoint, line}]
 */
export const getIntersectionPointsAndLines = (lines, intersectionPoint1, intersectionPoint2) => {
  let intersectionPoints = [];

  lines.forEach((line) => {
    let intersectionCords = getIntersectCords(
      Math.round10(line.from.x, -1), Math.round10(line.from.y, -1),
      Math.round10(line.to.x, -1), Math.round10(line.to.y, -1),
      Math.round10(intersectionPoint1.x, -1), Math.round10(intersectionPoint1.y, -1),
      Math.round10(intersectionPoint2.x, -1), Math.round10(intersectionPoint2.y, -1),
      false
    );
    if (intersectionCords) {
      intersectionPoints.push({intersectionCords, line});
    }
  });

  return intersectionPoints
}

/**
 *
 * @param circleX {int}
 * @param circleY {int}
 * @param circleRadius {int}
 * @param lineX1 {int}
 * @param lineY1 {int}
 * @param lineX2 {int}
 * @param lineY2 {int}
 * @return {null|{y1: *, x1: *, y2: *, x2: *}|{x: *, y: *}}
 */
export const getCircleLineIntersection = (circleX, circleY, circleRadius, lineX1, lineY1, lineX2, lineY2) => {
  const dx = lineX2 - lineX1;
  const dy = lineY2 - lineY1;
  const a = dx * dx + dy * dy;
  const b = 2 * (dx * (lineX1 - circleX) + dy * (lineY1 - circleY));
  const c = circleX * circleX + circleY * circleY + lineX1 * lineX1 + lineY1 * lineY1
    - 2 * (circleX * lineX1 + circleY * lineY1) - circleRadius * circleRadius;
  const delta = b * b - 4 * a * c;

  if (delta < 0) {
    return null; // no intersection
  } else if (delta === 0) {
    // the line is tangent to the circle
    const t = -b / (2 * a);
    const intersectionX = lineX1 + t * dx;
    const intersectionY = lineY1 + t * dy;
    return { x: intersectionX, y: intersectionY };
  } else {
    // the line intersects the circle at two points
    const t1 = (-b + Math.sqrt(delta)) / (2 * a);
    const t2 = (-b - Math.sqrt(delta)) / (2 * a);
    const intersection1X = lineX1 + t1 * dx;
    const intersection1Y = lineY1 + t1 * dy;
    const intersection2X = lineX1 + t2 * dx;
    const intersection2Y = lineY1 + t2 * dy;
    return { x1: intersection1X, y1: intersection1Y, x2: intersection2X, y2: intersection2Y };
  }
}
